export class QuestionTypes {
  static SINGLE_QUESTION = 'SingleSelect';
  static MULTI_QUESTION = 'MultiSelect';
  static DROPDOWN_QUESTION = 'Dropdown';
}
